//// Application Packages
import React from 'react'
import { useSelector } from 'react-redux'

//// Application Slices
import { selectSettings } from '../../reducers/settingSlice'
import { selectForms } from '../../reducers/formSlice'

//// Application Components

//// Carbon Components
import {
    TextInput,
    TextArea,
    Select,
    SelectItem,
    DatePicker,
    DatePickerInput,
    Button,
} from '@carbon/react'

//// Carbon Icons
import { Subtract } from '@carbon/icons-react'

//// Static Constants

//////// Component
const AdditionalSealedCriminalHistoryComponent = ({
    number,
    handleData,
    handleSubtractAdditionalSealedCriminalHistoryComponent,
    category_digital_name,
}) => {
    //////// Hooks

    //////// State

    //////// Slices
    const settingsData = useSelector(selectSettings)
    const formsData = useSelector(selectForms)

    //// Slice Data
    const digital_name = settingsData?.['form']?.['digital_name']

    //////// Search Params

    //////// Methods

    //////// Functional Methods

    //////// Memoization

    //////// Effects/Side Effects

    //////////////// Render & Return
    if (category_digital_name.includes('registered-nurse')) {
        return (
            <>
                <h4>Additional Sealed Criminal History:</h4>

                <TextInput
                    className="required"
                    labelText="Offense:"
                    id={'RSD40' + number}
                    name={'RSD40' + number}
                    placeholder="Offense"
                    value={
                        formsData?.[digital_name]?.values?.['RSD40' + number]
                    }
                    maxLength="60"
                    type="text"
                    onChange={handleData}
                    invalid={
                        formsData?.[digital_name]?.errors?.['RSD40' + number]
                    }
                    invalidText={
                        formsData?.[digital_name]?.errors?.[
                            'RSD40' + number + 'ErrMsg'
                        ]
                    }
                />

                <TextInput
                    className="required"
                    labelText="Jurisdiction:"
                    id={'RSD42' + number}
                    name={'RSD42' + number}
                    placeholder="Jurisdiction"
                    value={
                        formsData?.[digital_name]?.values?.['RSD42' + number]
                    }
                    maxLength="60"
                    type="text"
                    onChange={handleData}
                    invalid={
                        formsData?.[digital_name]?.errors?.['RSD42' + number]
                    }
                    invalidText={
                        formsData?.[digital_name]?.errors?.[
                            'RSD42' + number + 'ErrMsg'
                        ]
                    }
                />

                <DatePicker
                    dateFormat="m/d/Y"
                    datePickerType="single"
                    onChange={(e) => handleData(e, ['RSD41' + number])}
                    onClose={(e) => handleData(e, ['RSD41' + number])}
                    value={
                        formsData?.[digital_name]?.values?.['RSD41' + number]
                    }
                >
                    <DatePickerInput
                        className="required"
                        labelText="Date of Offense:"
                        id={'RSD41' + number}
                        name={'RSD41' + number}
                        placeholder="MM/DD/YYYY"
                        type="text"
                        invalid={
                            formsData?.[digital_name]?.errors?.[
                                'RSD41' + number
                            ]
                        }
                        invalidText={
                            formsData?.[digital_name]?.errors?.[
                                'RSD41' + number + 'ErrMsg'
                            ]
                        }
                    />
                </DatePicker>

                <TextInput
                    className="required"
                    labelText="Final Disposition:"
                    id={'FIN_DISP' + number}
                    name={'FIN_DISP' + number}
                    placeholder="Final Disposition"
                    value={
                        formsData?.[digital_name]?.values?.['FIN_DISP' + number]
                    }
                    maxLength="20"
                    type="text"
                    onChange={handleData}
                    invalid={
                        formsData?.[digital_name]?.errors?.['FIN_DISP' + number]
                    }
                    invalidText={
                        formsData?.[digital_name]?.errors?.[
                            'FIN_DISP' + number + 'ErrMsg'
                        ]
                    }
                />

                <Select
                    className="required"
                    defaultValue={
                        formsData?.[digital_name]?.values?.['RSD43' + number]
                    }
                    value={
                        formsData?.[digital_name]?.values?.['RSD43' + number]
                    }
                    helper=""
                    labelText="Under Appeal?"
                    id={'RSD43' + number}
                    name={'RSD43' + number}
                    onChange={handleData}
                    invalid={
                        formsData?.[digital_name]?.errors?.['RSD43' + number]
                    }
                    invalidText={
                        formsData?.[digital_name]?.errors?.[
                            'RSD43' + number + 'ErrMsg'
                        ]
                    }
                >
                    <SelectItem text="Choose an option" value="" />
                    <SelectItem text="Yes" value="Y" />
                    <SelectItem text="No" value="N" />
                </Select>

                <TextArea
                    className="required"
                    labelText="Applicant Statement:"
                    id={'LIC_NTS' + number}
                    name={'LIC_NTS' + number}
                    placeholder="Applicant Statement"
                    value={
                        formsData?.[digital_name]?.values?.['LIC_NTS' + number]
                    }
                    maxLength="4000"
                    type="textarea"
                    onChange={handleData}
                    invalid={
                        formsData?.[digital_name]?.errors?.['LIC_NTS' + number]
                    }
                    invalidText={
                        formsData?.[digital_name]?.errors?.[
                            'LIC_NTS' + number + 'ErrMsg'
                        ]
                    }
                />

                <div className="half-width-button-with-icon-group">
                    <div className="half-width-button-with-icon-group-item">
                        <Button
                            className="fldoh-btn"
                            name={number}
                            type="button"
                            kind="danger"
                            size="md"
                            onClick={
                                handleSubtractAdditionalSealedCriminalHistoryComponent
                            }
                        >
                            Remove
                            <Subtract />
                        </Button>
                    </div>
                </div>
            </>
        )
    } else if (category_digital_name.includes('licensed-practical-nurse')) {
        return (
            <>
                <h4>Additional Sealed Criminal History:</h4>

                <TextInput
                    className="required"
                    labelText="Offense:"
                    id={'OFFENSE' + number}
                    name={'OFFENSE' + number}
                    placeholder="Offense"
                    value={
                        formsData?.[digital_name]?.values?.['OFFENSE' + number]
                    }
                    maxLength="60"
                    type="text"
                    onChange={handleData}
                    invalid={
                        formsData?.[digital_name]?.errors?.['OFFENSE' + number]
                    }
                    invalidText={
                        formsData?.[digital_name]?.errors?.[
                            'OFFENSE' + number + 'ErrMsg'
                        ]
                    }
                />

                <TextInput
                    className="required"
                    labelText="Jurisdiction:"
                    id={'JURISDICTION' + number}
                    name={'JURISDICTION' + number}
                    placeholder="Jurisdiction"
                    value={
                        formsData?.[digital_name]?.values?.[
                            'JURISDICTION' + number
                        ]
                    }
                    maxLength="60"
                    type="text"
                    onChange={handleData}
                    invalid={
                        formsData?.[digital_name]?.errors?.[
                            'JURISDICTION' + number
                        ]
                    }
                    invalidText={
                        formsData?.[digital_name]?.errors?.[
                            'JURISDICTION' + number + 'ErrMsg'
                        ]
                    }
                />

                <DatePicker
                    dateFormat="m/d/Y"
                    datePickerType="single"
                    onChange={(e) => handleData(e, ['OFF_DATE' + number])}
                    onClose={(e) => handleData(e, ['OFF_DATE' + number])}
                    value={
                        formsData?.[digital_name]?.values?.['OFF_DATE' + number]
                    }
                >
                    <DatePickerInput
                        className="required"
                        labelText="Date of Offense:"
                        id={'OFF_DATE' + number}
                        name={'OFF_DATE' + number}
                        placeholder="MM/DD/YYYY"
                        type="text"
                        invalid={
                            formsData?.[digital_name]?.errors?.[
                                'OFF_DATE' + number
                            ]
                        }
                        invalidText={
                            formsData?.[digital_name]?.errors?.[
                                'OFF_DATE' + number + 'ErrMsg'
                            ]
                        }
                    />
                </DatePicker>

                <TextInput
                    className="required"
                    labelText="Final Disposition:"
                    id={'FINAL_DISP' + number}
                    name={'FINAL_DISP' + number}
                    placeholder="Final Disposition"
                    value={
                        formsData?.[digital_name]?.values?.[
                            'FINAL_DISP' + number
                        ]
                    }
                    maxLength="20"
                    type="text"
                    onChange={handleData}
                    invalid={
                        formsData?.[digital_name]?.errors?.[
                            'FINAL_DISP' + number
                        ]
                    }
                    invalidText={
                        formsData?.[digital_name]?.errors?.[
                            'FINAL_DISP' + number + 'ErrMsg'
                        ]
                    }
                />

                <Select
                    className="required"
                    defaultValue={
                        formsData?.[digital_name]?.values?.['APPEAL' + number]
                    }
                    value={
                        formsData?.[digital_name]?.values?.['APPEAL' + number]
                    }
                    helper=""
                    labelText="Under Appeal?"
                    id={'APPEAL' + number}
                    name={'APPEAL' + number}
                    onChange={handleData}
                    invalid={
                        formsData?.[digital_name]?.errors?.['APPEAL' + number]
                    }
                    invalidText={
                        formsData?.[digital_name]?.errors?.[
                            'APPEAL' + number + 'ErrMsg'
                        ]
                    }
                >
                    <SelectItem text="Choose an option" value="" />
                    <SelectItem text="Yes" value="Y" />
                    <SelectItem text="No" value="N" />
                </Select>

                <TextArea
                    className="required"
                    labelText="Applicant Statement:"
                    id={'LIC_NTS' + number}
                    name={'LIC_NTS' + number}
                    placeholder="Applicant Statement"
                    value={
                        formsData?.[digital_name]?.values?.['LIC_NTS' + number]
                    }
                    maxLength="4000"
                    type="textarea"
                    onChange={handleData}
                    invalid={
                        formsData?.[digital_name]?.errors?.['LIC_NTS' + number]
                    }
                    invalidText={
                        formsData?.[digital_name]?.errors?.[
                            'LIC_NTS' + number + 'ErrMsg'
                        ]
                    }
                />

                <div className="half-width-button-with-icon-group">
                    <div className="half-width-button-with-icon-group-item">
                        <Button
                            className="fldoh-btn"
                            name={number}
                            type="button"
                            kind="danger"
                            size="md"
                            onClick={
                                handleSubtractAdditionalSealedCriminalHistoryComponent
                            }
                        >
                            Remove
                            <Subtract />
                        </Button>
                    </div>
                </div>
            </>
        )
    }
}

export default AdditionalSealedCriminalHistoryComponent
